"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RagSettingsComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const events_1 = require("@front/components/form-parts/events");
require("@front/components/form-parts");
const rag_default_setup_1 = require("../../../../common/constants/rag-default-setup");
function escapeSeparatorForDisplay(sep) {
    return sep
        .replace(/\n/g, '\\n')
        .replace(/\t/g, '\\t')
        .replace(/\r/g, '\\r');
}
function unescapeSeparatorFromDisplay(sep) {
    return sep
        .replace(/\\n/g, '\n')
        .replace(/\\t/g, '\t')
        .replace(/\\r/g, '\r');
}
function separatorsToDisplay(seps) {
    return seps.map(escapeSeparatorForDisplay).join(', ');
}
function displayToSeparators(display) {
    return display.split(',').map((s) => unescapeSeparatorFromDisplay(s.trim())).filter(Boolean);
}
//@ts-ignore                
let rwsTemplate = T.html `<div class="rag-settings-component">
     <button 
                type="button" 
                class="btn btn-outline-secondary btn-sm mb-3"
                @click="${x => x.resetToDefaults()}"
                title="${'rag.settings.resetToDefaults.tooltip'.t()}">
                <i class="simple-icon-reload"></i> ${'rag.settings.resetToDefaults.label'.t()}
            </button>

    ${(0, fast_element_1.when)(x => x.indexing, (0, fast_element_1.html) `
    <div class="indexing-section mb-4">
        <h6 class="mb-3">${'settings.rag.indexing.title'.t()}</h6>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <part-slider 
                        class="form-part"
                        label="${'rag.settings.chunkSize.label'.t()}"
                        name="chunkSize"
                        min="100"
                        max="2000"
                        step="50"
                        labelBotMargin="35"
                        showValue="true"
                        unit=""
                        :value="${x => x.ragSettings.chunkSize}">
                    </part-slider>
                    <small class="text-muted d-block mt-1">${'rag.settings.chunkSize.description'.t()}</small>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <part-slider 
                        class="form-part"
                        label="${'rag.settings.chunkOverlap.label'.t()}"
                        name="chunkOverlap"
                        min="0"
                        max="500"
                        step="10"
                        labelBotMargin="35"
                        showValue="true"
                        unit=""
                        :value="${x => x.ragSettings.chunkOverlap}">
                    </part-slider>
                    <small class="text-muted d-block mt-1">${'rag.settings.chunkOverlap.description'.t()}</small>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <part-input 
                        class="form-part"
                        label="${'rag.settings.separators.label'.t()}"
                        name="separators"
                        :value="${x => x.separatorsString}"
                        placeholder="${'rag.settings.separators.placeholder'.t()}">
                    </part-input>
                    <small class="text-muted d-block mt-1">${'rag.settings.separators.description'.t()}</small>
                </div>
            </div>
        </div>
    </div>
    `)}

    ${(0, fast_element_1.when)(x => x.searching, (0, fast_element_1.html) `
    <div class="searching-section">
        <h6 class="mb-3">${'settings.rag.search.title'.t()}</h6>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <part-slider 
                        class="form-part"
                        label="${'rag.settings.similarityThreshold.label'.t()}"
                        name="similarityThreshold"
                        min="0.1"                    
                        max="1"
                        step="0.05"
                        labelBotMargin="35"
                        showValue="true"
                        unit=""
                        :value="${x => x.ragSettings.similarityThreshold}">
                    </part-slider>
                    <small class="text-muted d-block mt-1">${'rag.settings.similarityThreshold.description'.t()}</small>
                </div>
            </div>

            <div class="col-md-4">
                <div class="form-group">
                    <part-slider 
                        class="form-part"
                        label="${'rag.settings.defaultMaxResults.label'.t()}"
                        name="defaultMaxResults"
                        min="1"
                        max="20"                    
                        step="1"
                        labelBotMargin="35"
                        showValue="true"
                        unit=""
                        :value="${x => x.ragSettings.defaultMaxResults}">
                    </part-slider>
                    <small class="text-muted d-block mt-1">${'rag.settings.defaultMaxResults.description'.t()}</small>
                </div>
            </div>

            <div class="col-md-4">
                <div class="form-group">
                    <part-slider
                        class="form-part"
                        label="${'rag.settings.maxResults.label'.t()}"
                        name="maxResults"
                        min="1"
                        max="20"
                        step="1"
                        labelBotMargin="35"
                        showValue="true"
                        unit=""
                        :value="${x => x.ragSettings.maxResults}">
                    </part-slider>
                    <small class="text-muted d-block mt-1">${'rag.settings.maxResults.description'.t()}</small>
                </div>
            </div>
        </div>
    </div>
    `)}
</div>`;
require("./styles/layout.scss");
const styles = T.css `.rag-settings-component .form-group {
  margin-bottom: 1.5rem;
}
.rag-settings-component .form-control-range {
  margin-bottom: 0.5rem;
}
.rag-settings-component .range-value {
  margin-top: 0.5rem;
}
.rag-settings-component .range-value .badge {
  font-size: 0.875rem;
  padding: 0.375rem 0.75rem;
}
.rag-settings-component .range-value small {
  font-size: 0.75rem;
  margin-top: 0.25rem;
}
.rag-settings-component .separators-container {
  max-height: 200px;
  overflow-y: auto;
}
.rag-settings-component .separators-container .input-group .form-control {
  font-size: 0.875rem;
}
.rag-settings-component .separators-container .input-group .btn {
  padding: 0.25rem 0.5rem;
}
.rag-settings-component label {
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #495057;
}
.rag-settings-component input[type=range] {
  -webkit-appearance: none;
  height: 6px;
  border-radius: 3px;
  background: #ddd;
  outline: none;
}
.rag-settings-component input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #007bff;
  cursor: pointer;
  transition: background 0.3s ease;
}
.rag-settings-component input[type=range]::-webkit-slider-thumb:hover {
  background: #0056b3;
}
.rag-settings-component input[type=range]::-moz-range-thumb {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #007bff;
  cursor: pointer;
  border: none;
  transition: background 0.3s ease;
}
.rag-settings-component input[type=range]::-moz-range-thumb:hover {
  background: #0056b3;
}
.rag-settings-component .badge-primary {
  background-color: #007bff !important;
}
.rag-settings-component .badge-info {
  background-color: #17a2b8 !important;
}
.rag-settings-component .badge-success {
  background-color: #28a745 !important;
}
.rag-settings-component .badge-warning {
  background-color: #ffc107 !important;
  color: #212529 !important;
}
.rag-settings-component .badge-secondary {
  background-color: #6c757d !important;
}`;
const shadowOptions = { "mode": "open" };
let RagSettingsComponent = class RagSettingsComponent extends client_1.RWSViewComponent {
    constructor() {
        super();
        this.formNamePrefix = 'ragSettings';
        this.searching = true;
        this.indexing = false;
        this.ragSettings = {
            defaultMaxResults: rag_default_setup_1.RAG_DEFAULT_SETUP.search.defaultMaxResults,
            maxResults: rag_default_setup_1.RAG_DEFAULT_SETUP.search.maxResults,
            similarityThreshold: rag_default_setup_1.RAG_DEFAULT_SETUP.search.defaultSimilarityThreshold,
            chunkSize: rag_default_setup_1.RAG_DEFAULT_SETUP.chunking.chunkSize,
            chunkOverlap: rag_default_setup_1.RAG_DEFAULT_SETUP.chunking.chunkOverlap,
            separators: [...rag_default_setup_1.RAG_DEFAULT_SETUP.chunking.separators]
        };
        this.loading = false;
        this.separatorsString = separatorsToDisplay(rag_default_setup_1.RAG_DEFAULT_SETUP.chunking.separators);
    }
    // Watch for changes to ragSettings property
    ragSettingsChanged(oldValue, newValue) {
        // Initialize defaults only for missing values (don't overwrite DB values)
        if (newValue) {
            const initialized = { ...newValue };
            if (!initialized.defaultMaxResults && initialized.defaultMaxResults !== 0) {
                initialized.defaultMaxResults = rag_default_setup_1.RAG_DEFAULT_SETUP.search.defaultMaxResults;
            }
            if (!initialized.maxResults && initialized.maxResults !== 0) {
                initialized.maxResults = rag_default_setup_1.RAG_DEFAULT_SETUP.search.maxResults;
            }
            if (initialized.similarityThreshold === undefined || initialized.similarityThreshold === null) {
                initialized.similarityThreshold = rag_default_setup_1.RAG_DEFAULT_SETUP.search.defaultSimilarityThreshold;
            }
            if (!initialized.chunkSize && initialized.chunkSize !== 0) {
                initialized.chunkSize = rag_default_setup_1.RAG_DEFAULT_SETUP.chunking.chunkSize;
            }
            if (!initialized.chunkOverlap && initialized.chunkOverlap !== 0) {
                initialized.chunkOverlap = rag_default_setup_1.RAG_DEFAULT_SETUP.chunking.chunkOverlap;
            }
            if (!initialized.separators || !Array.isArray(initialized.separators) || initialized.separators.length === 0) {
                initialized.separators = [...rag_default_setup_1.RAG_DEFAULT_SETUP.chunking.separators];
            }
            this.separatorsString = separatorsToDisplay(initialized.separators);
            // Only update if values actually changed to avoid infinite loops
            if (JSON.stringify(this.ragSettings) !== JSON.stringify(initialized)) {
                this.ragSettings = initialized;
            }
        }
    }
    async connectedCallback() {
        super.connectedCallback();
        // Listen for form part changes
        this.on(events_1.inputEvents.changed, (event) => {
            const { fieldName, value } = event.detail;
            this.handleFieldChange(fieldName, value);
        });
    }
    handleFieldChange(fieldName, value) {
        switch (fieldName) {
            case 'similarityThreshold':
                this.ragSettings.similarityThreshold = Math.round(parseFloat(value) * 100) / 100;
                break;
            case 'defaultMaxResults':
                this.ragSettings.defaultMaxResults = Math.round(parseInt(value) || 3);
                break;
            case 'maxResults':
                this.ragSettings.maxResults = Math.round(parseInt(value) || 6);
                break;
            case 'chunkSize':
                this.ragSettings.chunkSize = Math.round(parseInt(value) || rag_default_setup_1.RAG_DEFAULT_SETUP.chunking.chunkSize);
                break;
            case 'chunkOverlap':
                this.ragSettings.chunkOverlap = Math.round(parseInt(value) || rag_default_setup_1.RAG_DEFAULT_SETUP.chunking.chunkOverlap);
                break;
            case 'separators':
                this.separatorsString = value;
                this.ragSettings.separators = displayToSeparators(String(value));
                break;
            default:
                return;
        }
        this.emitChange();
    }
    updateSimilarityThreshold(value) {
        this.ragSettings.similarityThreshold = Math.round(value * 100) / 100; // Round to 2 decimal places
        this.emitChange();
    }
    updateDefaultMaxResults(value) {
        this.ragSettings.defaultMaxResults = Math.round(value);
        this.emitChange();
    }
    updateMaxResults(value) {
        this.ragSettings.maxResults = Math.round(value);
        this.emitChange();
    }
    emitChange() {
        this.$emit('rag-settings-changed', {
            settings: { ...this.ragSettings },
            formField: this.formNamePrefix
        });
    }
    // Public method to set settings from parent component
    setSettings(settings) {
        this.ragSettings = {
            ...this.ragSettings,
            ...settings
        };
    }
    // Public method to get current settings
    getSettings() {
        return { ...this.ragSettings };
    }
    // Reset to default values
    resetToDefaults() {
        this.ragSettings = {
            defaultMaxResults: rag_default_setup_1.RAG_DEFAULT_SETUP.search.defaultMaxResults,
            maxResults: rag_default_setup_1.RAG_DEFAULT_SETUP.search.maxResults,
            similarityThreshold: rag_default_setup_1.RAG_DEFAULT_SETUP.search.defaultSimilarityThreshold,
            chunkSize: rag_default_setup_1.RAG_DEFAULT_SETUP.chunking.chunkSize,
            chunkOverlap: rag_default_setup_1.RAG_DEFAULT_SETUP.chunking.chunkOverlap,
            separators: [...rag_default_setup_1.RAG_DEFAULT_SETUP.chunking.separators]
        };
        this.separatorsString = separatorsToDisplay(rag_default_setup_1.RAG_DEFAULT_SETUP.chunking.separators);
        this.emitChange();
    }
};
exports.RagSettingsComponent = RagSettingsComponent;
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], RagSettingsComponent.prototype, "formNamePrefix", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], RagSettingsComponent.prototype, "searching", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], RagSettingsComponent.prototype, "indexing", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], RagSettingsComponent.prototype, "ragSettings", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], RagSettingsComponent.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], RagSettingsComponent.prototype, "separatorsString", void 0);
exports.RagSettingsComponent = RagSettingsComponent = __decorate([
    (0, client_1.RWSView)('rag-settings', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __metadata("design:paramtypes", [])
], RagSettingsComponent);
RagSettingsComponent.defineComponent();
